module.exports = __webpack_public_path__ + "media/เจี๊ยกค่อก.e010bd79.mp3";